import { ApiClient } from "@/services/ApiService";

export default {
  async deleteUserTest(id) {
    const response = await ApiClient.delete(`usertest/${id}`);
    return response.data;
  },
  async getUserTests() {
    const response = await ApiClient.get(`usertest`);
    return response.data;
  },
  async getUserTest(id) {
    const response = await ApiClient.get(`usertest/${id}`);
    return response.data;
  },
  async getPassedTest(id) {
    const response = await ApiClient.get(`usertest/passed-test/${id}`);
    return response.data;
  },
  async getCert(id) {
    const response = await ApiClient.get(`usertest/certificate/${id}`, {
      responseType: "blob"
    });
    return response.data;
  },
  async getPrivacyStatement() {
    const response = await ApiClient.get(`usertest/privacy`, {
      responseType: "blob"
    });
    return response.data;
  },
  async postUserTest(usertest) {
    const response = await ApiClient.post(`usertest`, usertest);
    return response.data;
  },
  async putUserTest(usertest) {
    const response = await ApiClient.put(
      `usertest/${usertest.userTestId}`,
      usertest
    );
    return response.data;
  }
};
